module.exports = {
        srcSet: __webpack_public_path__ + "92f80a77b7414295-300.webp"+" 300w"+","+__webpack_public_path__ + "e381647367160205-600.webp"+" 600w"+","+__webpack_public_path__ + "9a35f482a91053a1-1024.webp"+" 1024w",
        images: [{path: __webpack_public_path__ + "92f80a77b7414295-300.webp",width: 300,height: 130},{path: __webpack_public_path__ + "e381647367160205-600.webp",width: 600,height: 261},{path: __webpack_public_path__ + "9a35f482a91053a1-1024.webp",width: 1024,height: 445}],
        src: __webpack_public_path__ + "9a35f482a91053a1-1024.webp",
        toString: function(){return __webpack_public_path__ + "9a35f482a91053a1-1024.webp"},
        
        width: 1024,
        height: 445
      }